<template>
  <ul class="navbar-nav bg-gradient-dark sidebar sidebar-dark accordion" id="accordionSidebar">
    <a class="sidebar-brand d-flex align-items-center justify-content-center" href="/">
      <div class="sidebar-brand-icon rotate-n-15">
        <i class="fas fa-laugh-wink"></i>
      </div>
      <div class="sidebar-brand-text mx-3">
        <img src="static/logo.png" />
        {{this.$title_application }}
      </div>
    </a>

    <hr class="sidebar-divider my-0" />

    <li class="nav-item active">
      <a class="nav-link" href="/user">
        <!--<i class="fas fa-fw fa-tachometer-alt"></i>-->
        <span>Dashboard</span>
      </a>
    </li>

    <hr class="sidebar-divider" />

    <!--<div class="sidebar-heading">Interface</div>-->

    <li class="nav-item">
      <a class="nav-link">
        <span>Usuarios</span>
      </a>
    </li>

    <hr class="sidebar-divider d-none d-md-block" />
  </ul>
</template>

<script>
export default {
  name: "SideNav"
};
</script>



// WEBPACK FOOTER //
// src/layouts/SideNav.vue